import { size } from '@styles/theme'

import StyledTab from '@elements/Tab'
import { Tabs } from '@mui/material'
import { PiArrowsClockwiseBold, PiChatCircleBold, PiNewspaper, PiNewspaperBold } from 'react-icons/pi'
import { LuCaptions } from 'react-icons/lu'
import styled from '@emotion/styled'
import { TbNews, TbPhoto } from 'react-icons/tb'

const tabStyles = {
  position: 'relative',
  top: 0,
  minHeight: 0,
  borderBottom: '0.5px solid rgba(255,255,255,0.2)',
  backgroundColor: 'black',
  '& .MuiTab-root': {
    // NOTE: minWidth styles are useful for the icon variant if desired
    // minWidth: size(10),
    maxWidth: 'calc(100svw/4)',
    minHeight: 0,
    paddingBottom: size(2.5),
    alignItems: 'center',
  },
}

const TabLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: center;
`

const SocialProfileTabs = ({ selectedTab, setSelectedTab, className='', sx={}, slotProps={ tabs: {} } }) => {
  const isPosts = selectedTab === 0
  const isReposts = selectedTab === 1
  const isReplies = selectedTab === 2
  const isMedia = selectedTab === 3
  return (
    <Tabs
      className={className}
      sx={{ ...tabStyles, ...sx }}
      onChange={(_, val) => setSelectedTab(val)}
      aria-label="home view tabs"
      value={selectedTab}
      {...slotProps?.tabs || {}}>
      <StyledTab
        // label={<TabLabel><LuCaptions size={size(2.75)} />{isPosts && <>&nbsp;Posts</>}</TabLabel>}
        label='Posts'
        color={isPosts ? 'white' : 'grey'}
      />
      <StyledTab
        // label={<TabLabel><PiArrowsClockwiseBold style={{ transform: 'rotate(90deg)' }} size={size(2.5)} />{isReposts && <>&nbsp;Reposts</>}</TabLabel>}
        label='Reposts'
        color={isReposts ? 'white' : 'grey'}
      />
      <StyledTab
        // label={<TabLabel><PiChatCircleBold size={size(2.5)} />{isReplies && <>&nbsp;Replies</>}</TabLabel>}
        label='Replies'
        color={isReplies ? 'white' : 'grey'}
      />
      <StyledTab
        // label={<TabLabel><TbPhoto size={size(2.5)} />{isMedia && <>&nbsp;Media</>}</TabLabel>}
        label='Media'
        color={isMedia ? 'white' : 'grey'}
      />
    </Tabs>
  )
}

export { SocialProfileTabs }
